import { imageOptimize } from '@utils/images'
import classNames from 'classnames'
import { ForwardedRef, forwardRef, useCallback } from 'react'
import { Venue, VenueEvent } from 'types/model'

export const EventBanner = forwardRef(function VenuePageBanner(
  {
    event,
    venue,
    className,
    onClick,
  }: { event: VenueEvent; venue: Venue; className?: string; onClick?: (event: VenueEvent) => void },
  ref: ForwardedRef<HTMLDivElement>
) {
  const poster = event.primaryImage?.filename

  const bannerSrc = imageOptimize(poster, { w: '500', h: '750', dpr: '0.5', q: '20' })
  const logoSrc = imageOptimize(poster, {
    w: 'auto',
    h: 'auto',
    bg: 'transparent',
    fill: 'solid',
    dpr: '0.5',
    q: '20',
  })
  const handleClick = useCallback(() => {
    onClick?.(event)
  }, [event, onClick])

  if (!poster) return null
  return (
    <div
      ref={ref}
      onClick={handleClick}
      className={classNames(className, 'w-screen relative h-[156px] sm:h-[216px] overflow-hidden')}
    >
      <div
        className="absolute inset-0 w-full h-full overflow-hidden bg-scroll bg-center bg-cover blur"
        style={{ backgroundImage: `url(${bannerSrc})` }}
      ></div>
      <div className="absolute w-full h-full inset-0 bg-stone-900/[.8]"></div>
      <div className="absolute inset-0 flex items-center justify-center w-auto h-full">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          alt={event.name}
          src={logoSrc}
          loading="eager"
          className="w-auto h-auto max-w-full max-h-full"
        />
      </div>
    </div>
  )
})
